import { Box, Flex } from "@chakra-ui/react";
import LoginForm from "./components/loginForm";

function Login() {
  return (
    <Flex w={"100vw"} h={"100vh"}>
      <Box w={"100%"} h="100%" shadow={"md"} bgColor={"#F1F1F1"}>
        <Flex
          w="100%"
          h="100%"
          justifyContent={"center"}
          alignItems={"center"}
          bgImage={"./loginCliente.jpg"}
          bgSize={"cover"}
          
        >
          <Box 
          bgColor={"#0000006e"} 
          w={"25%"} 
          h={"50%"} 
          borderRadius={"20px"} 
          border={"4px solid #ffffff50"}
          filter={"blur"}
          backdropFilter={"auto"}
          >            
          <LoginForm />                      
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
}
export default Login;
